/* eslint-disable no-undef */
import { createAction } from "@reduxjs/toolkit";
import {
  SEARCH_COLLECTIONS_REQUEST,
  SEARCHING_COLLECTIONS_SUCCEEDED,
  SEARCHING_COLLECTIONS_FAILED,
  INVALIDATE_COLLECTION_SEARCH_RESULTS,
  SEARCH_STREAMS_REQUEST,
  SEARCHING_STREAMS_SUCCEEDED,
  SEARCHING_STREAMS_FAILED,
  INVALIDATE_STREAM_SEARCH_RESULTS,
  SEARCH_ASSETS_REQUEST,
  SEARCHING_ASSETS_SUCCEEDED,
  SEARCHING_ASSETS_FAILED,
  INVALIDATE_ASSET_SEARCH_RESULTS,
  SEARCH_GROUPS_REQUEST,
  SEARCHING_GROUPS_SUCCEDDED,
  SEARCHING_GROUPS_FAILED,
  INVALIDATE_GROUPS_SEARCH_RESULTS,
  SEARCH_DEAL_ROOMS,
  SEARCHING_DEAL_ROOMS_SUCCEEDED,
  SEARCHING_DEAL_ROOMS_FAILED,
  INVALIDATE_DEAL_ROOMS_SEARCH_RESULTS,
  SEARCH_LEARNERS_REQUEST,
  SEARCHING_LEARNERS_SUCCEEDED,
  SEARCHING_LEARNERS_FAILED,
  INVALIDATE_LEARNER_SEARCH_RESULTS,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED,
} from "./actionTypes";

import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { SearchAssetsErrorResponse, SearchAssetsRequest, SearchAssetsResponse, SearchCollectionsErrorResponse, SearchCollectionsRequest, SearchCollectionsResponse, SearchContactForAutoCompleteErrorResponse, SearchContactForAutoCompleteRequest, SearchContactForAutoCompleteResponse, SearchDealRoomsErrorResponse, SearchDealRoomsRequest, SearchDealRoomsResponse, SearchGroupsErrorResponse, SearchGroupsRequest, SearchGroupsResponse, SearchLearnersErrorResponse, SearchLearnersRequest, SearchLearnersResponse, SearchStreamsErrorResponse, SearchStreamsRequest, SearchStreamsResponse } from "../../types/search";
import buildUrl from "build-url-ts";
import _ from "lodash";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const coachingApiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;
const SEARCH_BASE_URL = `${apiUrl}/api/2.0/search`;
const DEAL_ROOMS_SEARCH_BASE_URL = `${apiUrl}/api/2.0/search/dealRoom`;
const CONTACT_BASE_URL = `${apiUrl}/api/2.0/contacts`;

export const searchCollections = createAction<SearchCollectionsRequest>(SEARCH_COLLECTIONS_REQUEST);
const searchingCollectionsSucceeded = createAction<SearchCollectionsResponse>(SEARCHING_COLLECTIONS_SUCCEEDED);
const searchingCollectionsFailed = createAction<SearchCollectionsErrorResponse>(SEARCHING_COLLECTIONS_FAILED);

const searchCollectionsSaga = function* (action: ReturnType<typeof searchCollections>): any {
  const request = action.payload;

  const url = buildUrl(SEARCH_BASE_URL, {
    path: `collections/${request.page}`,
  });

  const params = _.omit(request, ["page"]);
  params["orderBy"] = _.get(request, "orderBy", "name");
  params["sortBy"] = _.get(request, "sortBy", "asc");

  const fetchCollectionsApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: {
        ...params,
        includeDealRoom: false
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionsApi);
    yield put(searchingCollectionsSucceeded({
      query: request.query,
      response: response
    }));
  } catch (error) {
    yield put(searchingCollectionsFailed({ query: request.query, error: error }));
  }
};

export const invalidateCollectionsSearchResults = createAction<void>(INVALIDATE_COLLECTION_SEARCH_RESULTS);

export const searchDealRooms = createAction<SearchDealRoomsRequest>(SEARCH_DEAL_ROOMS);
const searchingDealRoomsSucceeded = createAction<SearchDealRoomsResponse>(SEARCHING_DEAL_ROOMS_SUCCEEDED);
const searchingDealRoomsFailed = createAction<SearchDealRoomsErrorResponse>(SEARCHING_DEAL_ROOMS_FAILED);

const searchDealRoomsSaga = function* (action: ReturnType<typeof searchDealRooms>): any {
  const request = action.payload;

  const url = buildUrl(DEAL_ROOMS_SEARCH_BASE_URL, {
    path: `${request.page}`,
  });

  const params = _.omit(request, ["page"]);

  const fetchDealRoomsApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealRoomsApi);
    yield put(searchingDealRoomsSucceeded({
      query: request.query,
      response: response
    }));
  } catch (error) {
    yield put(searchingDealRoomsFailed({ query: request.query, error: error }));
  }
};

export const invalidateDealRoomsSearchResults = createAction<void>(INVALIDATE_DEAL_ROOMS_SEARCH_RESULTS);


//Search Streams
export const searchStreams = createAction<SearchStreamsRequest>(SEARCH_STREAMS_REQUEST);
const searchingStreamsSucceeded = createAction<SearchStreamsResponse>(SEARCHING_STREAMS_SUCCEEDED);
const searchingStreamsFailed = createAction<SearchStreamsErrorResponse>(SEARCHING_STREAMS_FAILED);

const searchStreamsSaga = function* (action: ReturnType<typeof searchCollections>): any {
  const request = action.payload;

  const url = buildUrl(SEARCH_BASE_URL, {
    path: `streams/${request.page}`,
  });

  const params = _.omit(request, ["page"]);

  const fetchStreamsApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamsApi);
    yield put(searchingStreamsSucceeded({
      query: request.query,
      response: response
    }));
  } catch (error) {
    yield put(searchingStreamsFailed({ query: request.query, error: error }));
  }
};

export const invalidateStreamsSearchResults = createAction<void>(INVALIDATE_STREAM_SEARCH_RESULTS);

//Search Assets
export const searchAssets = createAction<SearchAssetsRequest>(SEARCH_ASSETS_REQUEST);
const searchingAssetsSucceeded = createAction<SearchAssetsResponse>(SEARCHING_ASSETS_SUCCEEDED);
const searchingAssetsFailed = createAction<SearchAssetsErrorResponse>(SEARCHING_ASSETS_FAILED);

const searchAssetsSaga = function* (action: ReturnType<typeof searchAssets>): any {
  const request = action.payload;

  const url = buildUrl(SEARCH_BASE_URL, {
    path: `assets/${request.page}`,
  });

  const params = _.omit(request, ["page"]);

  const fetchAssetsApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetsApi);
    yield put(searchingAssetsSucceeded({
      query: request.query,
      response: response
    }));
  } catch (error) {
    yield put(searchingAssetsFailed({ query: request.query, error: error }));
  }
};

export const invalidateAssetsSearchResults = createAction<void>(INVALIDATE_ASSET_SEARCH_RESULTS);

// Search Group
export const searchGroups = createAction<SearchGroupsRequest>(SEARCH_GROUPS_REQUEST);
const searchingGroupsSucceeded = createAction<SearchGroupsResponse>(SEARCHING_GROUPS_SUCCEDDED);
const searchingGroupsFailed = createAction<SearchGroupsErrorResponse>(SEARCHING_GROUPS_FAILED);

const searchGroupsSaga = function* (action: ReturnType<typeof searchGroups>): any {
  const request = action.payload;

  const url = buildUrl(SEARCH_BASE_URL, {
    path: `groups/${request.page}`,
  });

  const params = _.omit(request, ["page"]);

  const fetchGroupsApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGroupsApi);
    yield put(searchingGroupsSucceeded({
      query: request.query,
      response: response
    }));
  } catch (error) {
    yield put(searchingGroupsFailed({ query: request.query, error: error }));
  }
};

export const invalidateGroupsSearchResults = createAction<void>(INVALIDATE_GROUPS_SEARCH_RESULTS);

// Search active learners for a course
export const searchLearners = createAction<SearchLearnersRequest>(SEARCH_LEARNERS_REQUEST);
const searchingLearnersSucceeded = createAction<SearchLearnersResponse>(SEARCHING_LEARNERS_SUCCEEDED);
const searchingLearnersFailed = createAction<SearchLearnersErrorResponse>(SEARCHING_LEARNERS_FAILED);

const searchLearnersSaga = function* (action: ReturnType<typeof searchLearners>): any {
  const request = action.payload;

  const { page, query } = action.payload;

  const url = buildUrl(coachingApiUrl, {
    path: 'api/1.0/courses/learners/search',
  });

  const fetchLearnersAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page: page,
        query: query
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearnersAPI);
    yield put(searchingLearnersSucceeded({
      query: request.query,
      response: response
    }));
  } catch (error) {
    yield put(searchingLearnersFailed({ query: request.query, error: error }));
  }
};

export const invalidateLearnerSearchResults = createAction<void>(INVALIDATE_LEARNER_SEARCH_RESULTS);

export const searchContactForAutoComplete = createAction<SearchContactForAutoCompleteRequest>(SEARCHING_CONTACT_FOR_AUTOCOMPLETE);
const searchingContactForAutoCompleteSucceeded = createAction<SearchContactForAutoCompleteResponse>(SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED);
const searchingContactForAutoCompleteFailed = createAction<SearchContactForAutoCompleteErrorResponse>(SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED);

const searchContactForAutoCompleteSaga = function* (action: ReturnType<typeof searchContactForAutoComplete>): any {
  const { query, type } = action.payload;

  let params = {
    type: type || "both",
    global: false,
    query: query,
    page: 0,
    limit: 25,
  };

  const searchContactForAutoCompleteAPI = () => {
    return axios({
      method: 'GET',
      url: CONTACT_BASE_URL,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(searchContactForAutoCompleteAPI);
    yield put(searchingContactForAutoCompleteSucceeded({
      query: query,
      response: response
    }));
  } catch (error) {
    yield put(searchingContactForAutoCompleteFailed({ query: query, error: error }));
  }
}

export default function* searchSaga(): any {
  yield takeEvery(SEARCH_COLLECTIONS_REQUEST, searchCollectionsSaga);
  yield takeEvery(SEARCH_STREAMS_REQUEST, searchStreamsSaga);
  yield takeEvery(SEARCH_GROUPS_REQUEST, searchGroupsSaga);
  yield takeEvery(SEARCH_ASSETS_REQUEST, searchAssetsSaga);
  yield takeEvery(SEARCH_DEAL_ROOMS, searchDealRoomsSaga);
  yield takeEvery(SEARCH_LEARNERS_REQUEST, searchLearnersSaga);
  yield takeEvery(SEARCHING_CONTACT_FOR_AUTOCOMPLETE, searchContactForAutoCompleteSaga);
};